import './css/style.scss';
import './i18n/i18n';

import { b2x } from '@b2x/react/src';
import React from 'react';
import ReactDOM from 'react-dom/client';

import { App } from './App';
import { Button, ButtonVariant } from './Button';
import { Container } from './Container';
import { en } from './i18n/locales/en';
import { it } from './i18n/locales/it';
import { IconName, IconSize } from './Icon';
import { ThemeColor } from './pages/TemplatePage';
import { reportWebVitals } from './reportWebVitals';

b2x.init<ThemeColor, ButtonVariant, IconName, IconSize>({
  api: {
    apiKey: 'GIGADIDAABHBDBHCGIBEJD',
    productTilePopulate: {},
    sessionOptions: {
      populate: {},
    },
  },
  defaultButtonVariant: 'primary',
  i18n: {
    en: en,
    it: it,
  },
  preRelease: true,
  projectName: 'asroma',
  ui: 'bs5',
  variants: {
    Button: Button,
    Container: Container,
    LocaleForm: 'B',
  },
});

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <React.StrictMode>
    <b2x.router.BrowserRouter>
      <b2x.ModalsContext>
        <App />
      </b2x.ModalsContext>
    </b2x.router.BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
